<div class="card__section">
  <div class="row">
    <div class="columns">
      <h3 class="card__title card__title--large u-m-b-8">Schedules</h3>
    </div>
    <div class="columns shrink">
      <p class="u-m-b-0 typography--body" aria-live="polite">
        Viewing <strong>{{ (opusJobs$ | async)?.length || 0 }}</strong> Job Schedules
      </p>
    </div>
  </div>
</div>
<div class="card__section">
  <div class="row align-middle">
    <div class="columns">
      <label for="stateFilter">State</label>
      <select id="stateFilter" class="u-m-b-0" [formControl]="stateCtrl">
        <option [ngValue]="null">All</option>
        <option *ngFor="let s of states" [value]="s.value">{{ s.key }}</option>
      </select>
    </div>
  </div>
</div>
